/**
 * Sitewide beoordeling op schaal 10 (= gemiddelde 5★-score × 2).
 * (Google + Trustpilot) / 2, daarna × 2 voor schaal 10.
 * Vult [data-uf-review-score-10] (banner, beloftes, …).
 */
(function () {
  'use strict';

  var API = 'https://tracker.urbanfloors.nl/api/reviews';

  function averageScore5(data) {
    if (!data) return 0;
    var sum = 0;
    var n = 0;
    if (data.trustpilot && Number(data.trustpilot.score) > 0) {
      sum += Number(data.trustpilot.score);
      n += 1;
    }
    if (data.google && Number(data.google.score) > 0) {
      sum += Number(data.google.score);
      n += 1;
    }
    if (!(n > 0)) return 0;
    return Math.round((sum / n) * 10) / 10;
  }

  function formatNl(n) {
    return String(n).replace('.', ',');
  }

  var lastScore10 = 0;

  function applyScore10(score10) {
    if (!(score10 > 0)) return;
    lastScore10 = score10;
    var label = formatNl(score10);
    document.querySelectorAll('[data-uf-review-score-10]').forEach(function (el) {
      el.textContent = label;
    });
  }

  function refresh() {
    if (lastScore10 > 0) applyScore10(lastScore10);
  }

  function boot() {
    if (!document.querySelector('[data-uf-review-score-10]')) return;
    var ufFetch =
      window.UF_OFFLINE && typeof window.UF_OFFLINE.fetch === 'function'
        ? window.UF_OFFLINE.fetch
        : fetch;
    ufFetch(API, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('reviews ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var s5 = averageScore5(data);
        if (s5 > 0) applyScore10(Math.round(s5 * 2 * 10) / 10);
      })
      .catch(function () {
        /* keep Liquid fallback */
      });
  }

  window.UfReviewScore = {
    refresh: refresh,
    apply: applyScore10,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
